export default __webpack_public_path__ + "static/media/13.21cab8e4.svg";